import React from 'react';
// @mui
import { Box, Typography } from '@mui/material';

interface PageHeaderProps {
  title: string;
  button?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, button }) => (
  <Box>
    <Typography variant="h3" sx={{ mb: 0.5, display: 'inline-block' }}>
      {title}
    </Typography>
    {button && <Box sx={{ display: 'inline-block' }}>{button}</Box>}
  </Box>
);

export default PageHeader;
